<template>
<div id="ProductFormMeli">  
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  > 
  <!-- <v-row>   -->
            <v-row  v-if="hasMeli">                
                <v-col cols="12" sm="12" md="4"></v-col>                                                
                <v-col cols="12" sm="12" md="4">
                  <!-- <v-text-field
                      v-model="productInfo.pricelistwoo.id"
                      v-if="hasWoo"
                      label="*ID Woo"
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>  -->
                </v-col>                                                
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                      v-model="productInfo.pricelistmeli.meli_id"
                      v-if="hasMeli"
                      label="*Clave Meli"
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>  
                  <v-switch
                    v-if="hasMeli"
                    v-model="productInfo.pricelistmeli.ver"
                    label="MELI"
                  ></v-switch>                        
                </v-col>                                                
            </v-row>
            <v-row  v-if="hasWoo">  
                <v-col cols="12" sm="12" md="4"></v-col>                                                
                <v-col cols="12" sm="12" md="4"></v-col>                                                
                <v-col cols="12" sm="12" md="4">
                  <v-text-field
                      v-model="productInfo.pricelistwoo.woo_id"
                      v-if="hasWoo"
                      label="*Clave Woo"
                      :rules="[
                        //required('syscom_id'),
                        //onlyNumeric('syscom_id'),
                      ]"
                  ></v-text-field>  
                  <v-switch
                    v-if="hasWoo"
                    v-model="productInfo.pricelistwoo.ver"
                    label="Woo"
                  ></v-switch>                        
                </v-col>
            </v-row>

            <v-row>       
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                      v-if="hasWoo"
                      v-model="productInfo.pricelistwoo.destacado"
                      label="Destado*"                       
                    />       
              </v-col>                                            
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                    v-model="productInfo.pricelistmeli.comision"
                    v-if="hasMeli"                    
                    label="Comision"                  
                ></v-text-field>
                <v-text-field
                    v-model="productInfo.pricelistwoo.comision"
                    v-if="hasWoo"                    
                    label="Comision"                
                ></v-text-field>
              </v-col>    
              <v-col cols="12" sm="6" md="4">
                <v-combobox
                    v-if="hasMeli"
                    v-model="productInfo.pricelistmeli.shipping"
                    :items="itemsTypeArticle"
                    label="Seleccione un tipo de envio"
                    :rules="[
                      required('tipo de articulo')
                    ]"       
                  ></v-combobox>  
                  <v-text-field
                    v-model="productInfo.pricelistwoo.variation_parentid"
                    v-if="hasWoo"
                    label="Variacion ID"
                  ></v-text-field> 
               
              </v-col>    
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-if="hasMeli"
                    v-model="productInfo.pricelistmeli.price"
                    label="Precio*"                       
                  /> 
                  <v-text-field
                    v-if="hasWoo"
                    v-model="productInfo.pricelistwoo.price"
                    label="Precio*"                       
                  /> 
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-if="hasMeli"
                    v-model="productInfo.pricelistmeli.existencia"
                    label="Existencias*"                       
                  /> 
                  <v-text-field
                    v-if="hasWoo"
                    v-model="productInfo.pricelistwoo.existencia"
                    label="Existencias*"                       
                  /> 
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-if="hasMeli"
                    v-model="productInfo.pricelistmeli.categoryid"
                    label="Categoria*"                       
                  /> 
                  <v-combobox
                    v-if="hasWoo"
                    v-model="productInfo.pricelistwoo.clase"
                    :items="itemsClase"
                    label="Seleccione una clase"
                    :rules="[
                      required('Clase')
                    ]"       
                  ></v-combobox> 
                </v-col>
              </v-row> 

              <!-- <v-row  v-if="hasProduct">
                <v-col cols=12 xs=6 sm=6  md=6  lg=6  xl=6 >
                  <h5>Woocomerce</h5>
                </v-col>
                <v-col cols=12 xs=6 sm=6  md=6  lg=6  xl=6 >
                  <v-switch
                    v-if="hasProduct"
                    v-model="productWooInfo.woo"
                    label="Woo"
                  ></v-switch> 
                </v-col>
              </v-row>
              <v-row v-if="productWooInfo.woo==1">
                <v-col cols=12 xs=12 sm=12  md=4  lg=3  xl=3 >
                  <v-text-field
                      v-model="productInfo.pricelistwoo.clase"
                      v-if="hasProduct"
                      label="Clase de Envio"
                  />
                </v-col>
                <v-col cols=12 xs=12 sm=12  md=4  lg=3  xl=3 >
                  <v-text-field
                      v-model="productInfo.pricelistwoo.peso"
                      v-if="hasProduct"
                      label="Peso"
                  />
                </v-col>            
                <v-col cols=12 xs=12 sm=12  md=4  lg=3  xl=3 >
                  <v-text-field
                      v-model="productInfo.woo_id"
                      v-if="hasProduct"
                      label="Woo ID"
                  />
                </v-col>
                <v-col cols=12 xs=12 sm=12  md=12  lg=12  xl=12 >
                  <v-btn
                          color="purple"
                          class="mr-4"
                          @click="updateWooForm(productInfo.pricelistwoo)" 
                  >
                        <v-icon>save</v-icon> {{buttonText}}
                  </v-btn>    
                </v-col>
              </v-row>                               -->
              <v-row>
                <v-col cols="12">
                  <v-textarea
                      v-if="hasMeli"
                      v-model="productInfo.pricelistmeli.description"          
                      filled
                      auto-grow
                      label="Escribe descripcion del producto"
                      rows="4"
                      row-height="30"
                      shaped
                  ></v-textarea>  
                  <v-textarea
                      v-if="hasWoo"
                      v-model="productInfo.pricelistwoo.description"          
                      filled
                      auto-grow
                      label="Escribe descripcion del producto"
                      rows="4"
                      row-height="30"
                      shaped
                  ></v-textarea>  
                </v-col>
              </v-row>

    <v-row>
      <v-col cols="12" >
        <v-btn
                v-if="hasReset"
                color="error"
                class="mr-4"
                @click="reset"
              >
                <v-icon>cleaning_services</v-icon> Reset Form
        </v-btn> 
        <v-btn
                v-if="hasMeli || hasWoo"
                color="primary"
                class="mr-4"
                @click="submitForm(productInfo)" 
                :disabled="!valid"                
        >
              <v-icon>save</v-icon> {{buttonText}}
        </v-btn>                       
        <!-- <v-btn
                            v-if="hasLoadProduct"
                            class="mr-4"
                            color="blue darken-1"                            
                            @click="getDataProduct(hasValorID)"
                          >
                             <v-icon>refresh</v-icon>
                             Cargar Datos
                          </v-btn> -->
                          <!-- {{ productInfo.id }} - ID - {{ hasValorID }} -->
                         

      </v-col>
    </v-row>
  </v-form>
</div>
</template>

<script>
// import{ mapMutations,mapState } from "vuex";
import{ mapMutations } from "vuex";
import validations from '@/utils/validation';
// import{ DataManager,Query, WebApiAdaptor } from "@syncfusion/ej2-data";
import baseApi from '@/services/baseApi';
import router from '@/router';


export default {
  name: 'ProductFormMeli',  
  components: {
  },  
  computed:{
    // 'products',
    // ...mapState(['priceslist','familycategories','subfamilies']) 
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    async getPrice2(){     
      try{        
        this.showLoading({titulo:"Accediendo información",color:"primary"})        
        // console.log("Pricelist "+sword);
        // await this.$store.dispatch('loadPricelists',"All"); //component PricelistItem
        let key=1;
        switch (key) {
          case 1:
            console.log(key);
            break;
        
          default:
            break;
        }
        console.log('Product Form:'+this.$route.name);
        // await this.$store.dispatch('loadFamilyCategories',this.attribute); //se carga para component PricelistItem
        // await this.$store.dispatch('loadSubFamilies',this.attribute); //se carga para component PricelistItem

      }catch(error){       
        if (error.message=='Request failed with status code 500') {
          this.$swal("Error!",error.message+"<br/> Intente Nuevamente o verifique todos los campos", "error");
        }else if(error.message=='Request failed with status code 401'){
          this.$swal("Error!", "Ha terminado la sesion <br/>Por seguridad ingrese de nuevo sus credenciales", "error");
          router.push('/login');
        }else{
          this.$swal("Error!", "Algo salio mal, Intente nuevamente <br/>"+error, "error");
        } 
      }  finally{
        this.hiddenLoading()
      } 
      
    },
    reset () {
        this.$refs.form.reset()
    },
    getSyscom(pricelist_id) {
          try{        
            this.showLoading({titulo:"Accediendo información en Syscom",color:"warning"})
            baseApi().get(`/syscom/product/${pricelist_id}`).then((response)=>{
              if(!response.data.error){
                this.productInfo=response.data;     
                // this.productInfo.pricelistwoo.price=response.data.price_publico;
                //this.$swal("Genial!",response.data.message, "success");
                // this.dialog10=true;
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                  
              //console.log("VENTA: "+response.data.message);
            });
          }catch(error){
            console.log(error);
          }finally{
            this.hiddenLoading()
          }       
    },
    getDataProduct(pricelist_id) {
          try{        
            this.showLoading({titulo:"Accediendo información del Cliente",color:"warning"})
            baseApi().get(`precios/${pricelist_id}`).then((response)=>{
              if(!response.data.error){
                this.productInfo=response.data;                             
                //this.$swal("Genial!",response.data.message, "success");
                // this.dialog10=true;
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                  
              //console.log("VENTA: "+response.data.message);
            });
          }catch(error){
            console.log(error);
          }finally{
            this.hiddenLoading()
          } 
      },
  },
  props: {
    user: Object,
    product: Object,
    submitForm:String,
    buttonText:String,
    hasValorID:Number,
    hasWoo:String,hasMeli:String,
    hasReset:String
  },
  data(){
     return{
        valid: false,
        ...validations,
        attribute: {sword: 'All',limit: 27},        
        productWooInfo:{
          id:this.product ? this.product.id : "",
          woo_id:this.product ? this.product.woo_id : "",
          pricelist_id:this.product ? this.product.pricelist_id : "",
          clase:this.product ? this.product.clase : "heavy-paquete",
          woo:this.product ? this.product.woo : "",
        },
        productInfo:{   
          id:this.product ? this.product.id : "",
          meli_id:this.product ? this.product.meli_id : "",
          peso:this.product ? this.product.peso : "",
          clave_sat:this.product ? this.product.clave_sat : "",
          sku:this.product ? this.product.sku : "",
          modelo:this.product ? this.product.modelo : "",
          syscom_id:this.product ? this.product.syscom_id : "0",
          ctonline_id:this.product ? this.product.ctonline_id : "0",
          cva_id:this.product ? this.product.cva_id : "0",
          stock_syscom:this.product ? this.product.stock_syscom : "0",
          quote_id:this.product ? this.product.quote_id : "",
          salesorder_id:this.product ? this.product.salesorder_id : "",
          brand_id:this.product ? this.product.brand_id : "",
          measurement_id:this.product ? this.product.measurement_id : "",
          famcategory_id:this.product ? this.product.famcategory_id : "",
          subfamily_id:this.product ? this.product.subfamily_id : "",
          supplier_id:this.product ? this.product.supplier_id : "",
          pricelist_id:this.product ? this.product.pricelist_id : "",
          category:this.product ? this.product.category : "otro",
          customergroup_id:this.product ? this.product.customergroup_id : "1",
          prodcategory_id:this.product ? this.product.prodcategory_id : '1',
          currency_id:this.product ? this.product.currency_id : '14',
          line_id:this.product ? this.product.line_id :  '1',
          metrica:this.product ? this.product.metrica : "",          
          filename:this.product ? this.product.filename : 'https://www.ionoff.com.mx/wp-content/uploads/2019/07/iOnOff_logo_100x100.png',
          canasta_basica:'0',
          type_article:this.product ? this.product.type_article : 'Productos',
          posicion:this.product ? this.product.type_article : '1',
          description:this.product ? this.product.description : "",         
          price:this.product ? this.product.price : "",
          cantidad:this.product ? this.product.cantidad : "",
          min_stock:this.product ? this.product.min_stock : "0",
          max_stock:this.product ? this.product.max_stock : "0",
          comision:this.product ? this.product.comision : "2.99",          
          shipping_cost:this.product ? this.product.shipping_cost : "0", 
          other_cost:this.product ? this.product.other_cost : "0", 
          num_pedimento:this.product ? this.product.num_pedimento : "0",
          status:this.product ? this.product.status : "Público", 
          notes:this.product ? this.product.notes : "", 
        },        
        itemsTypeArticle:[
          // 'KIT',
          'normal',
          'clasic',
          'gold'
        ],
        itemsClase:[
          'normal-paquete',
          'semiheavy-paquete',
          'heavy-paquete',
        ],
              
        // dataItem2:new DataManager({
        //     url: "https://www.cloudbits.org.mx/fw/lumen/check/productos/getall",
        //     adaptor: new WebApiAdaptor,
        //     crossDomain:false,
        //     //dataType: 'json',
        //     //method: 'GET',
        //     headers: [
        //       {'Access-Control-Allow-Origin': '*'},
        //       {'Access-Control-Allow-Headers': '*'},
        //       {"Api-Token": 'gRTjsp26Gu27KVq0oZco24q3TmEayjM0QFlIrjm5WHZOBWCnK2GvAA4FYaxr'},
        //     ]
        //   }).executeQuery(new Query()).then((e) => {
        //     console.log(e.data);
        //   }),                  
        //   dataFields2:{value:'id',text:'sku'},
        //   //dataFields2:{value:'EmployeeID',text:'FirstName'},
        // };  
     }
  },
  destroyed() {
    console.log("Componente eliminado");
  },
  mounted(){
    console.log("Montado Product Form");
    if (this.hasValorID>0) {
      this.getDataProduct(this.hasValorID)
    }
  },
  created(){
    this.getPrice2()    
  }  
}
</script>